import ScrollReveal from './ScrollReveal';
import AnimatedText from './AnimatedText';

const PainPointSection = () => {
  return (
    <section className="py-12 md:py-16 relative overflow-hidden">
      <div className="container-premium">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            <p className="text-gold tracking-[0.2em] uppercase text-sm mb-6">
              Il problema
            </p>
          </ScrollReveal>
          
          <AnimatedText
            as="h2"
            text="Stanco di agenzie che promettono follower ma non portano fatturato?"
            className="font-serif text-3xl md:text-4xl lg:text-5xl mb-8 leading-loose pb-6"
            letterByLetter={false}
          />
          
          <ScrollReveal delay={0.3}>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-12">
              Troppi imprenditori investono nel digitale senza vedere risultati concreti. 
              Like, visualizzazioni, impression... <span className="text-foreground">ma il fatturato?</span>
            </p>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
            {[
              { number: '67%', text: 'delle PMI non ha una strategia digitale chiara' },
              { number: '80%', text: 'spreca budget in campagne senza ROI misurabile' },
              { number: '45%', text: 'non sa interpretare i dati del proprio marketing' },
            ].map((stat, index) => (
              <ScrollReveal key={index} delay={0.2 * (index + 1)}>
                <div className="glass-card-hover p-6">
                  <p className="text-3xl md:text-4xl font-serif text-gradient-gold mb-3">
                    {stat.number}
                  </p>
                  <p className="text-muted-foreground text-sm">
                    {stat.text}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainPointSection;
